const doc = [({"da":({"js":({"merfoto":({"orders":({"table":({"quantity_sum":"Antal varer"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;